// extracted by mini-css-extract-plugin
export var chevronIcon = "_9y-2";
export var teamName = "_9y-1";
export var teamSwitcherButton = "_9y-0";